module.exports = __webpack_public_path__ + "static/img/restaurant-view-tabs02.da1282a8.svg";